import React from 'react';
import { formatTime } from '../utils/helpers';
import OrderCard from './OrderCard';

function isHtml(str) {
  return /<[a-z][\s\S]*>/i.test(str);
}

function extractTable(html) {
  const match = html.match(/<table[\s\S]*?<\/table>/i);
  return match ? match[0] : null;
}

function wrapTablesWithScroll(html, orderNumber) {
  return html.replace(/<table[\s\S]*?<\/table>/gi, (match) => {
    // Count columns from the first row (header or data row)
    const firstRowMatch = match.match(/<tr[^>]*>([\s\S]*?)<\/tr>/);
    const columnCount = (firstRowMatch?.[1]?.match(/<(th|td)[^>]*>/gi) || []).length;
    
    // Add scroll wrapper only if more than 6 columns
    const wrapperClass = columnCount > 6 ? 'table-scroll-wrapper' : '';
    const wrapper = wrapperClass ? `<div class="${wrapperClass}">${match}</div>` : match;
    
    const header = orderNumber
      ? `<div class="table-order-header">Order number ${orderNumber}</div>`
      : '';
    return `${header}${wrapper}`;
  });
}

function formatFileSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function ChatMessage({ msg, onRetry, onRetryLiveAgent }) {
  // if (msg.role === 'status') {
  //   return (
  //     <div className="msg-status">
  //       {msg.content}
  //     </div>
  //   );
  // }

  const hasOrderCard = !!msg.orderCard;
  const hasTable = msg.content && /<table[\s\S]*?<\/table>/i.test(msg.content);
  const showTableOnly = hasTable && hasOrderCard;
  const agentLabel = msg.agentType === 'live'
    ? (msg.agentName ? `${msg.agentName} (Live Agent)` : 'Live Agent')
    : 'Honeywell Assist';
  const isAssistantMsg = msg.role === 'assistant';

  return (
    <>
      <div className={`message ${msg.role} ${isAssistantMsg ? `agent-${msg.agentType}` : ''}`}>
        {showTableOnly ? (
          <div dangerouslySetInnerHTML={{ __html: wrapTablesWithScroll(extractTable(msg.content), msg.tableOrderNumber || msg.orderCard?.order_number) }} />
        ) : (
          <>
            {msg.content && msg.connecting ? (
              <div className="live-agent-connecting">
                <span className="live-agent-connecting-spinner" aria-hidden="true" />
                <span className="live-agent-connecting-text">{msg.content}</span>
              </div>
            ) : msg.content && isHtml(msg.content) ? (
              <div dangerouslySetInnerHTML={{ __html: wrapTablesWithScroll(msg.content, msg.tableOrderNumber || msg.orderCard?.order_number) }} />
            ) : msg.content ? (
              <div>{msg.content}</div>
            ) : null}
            {hasOrderCard && <OrderCard order={msg.orderCard} />}
            {msg.attachment && (
              <a
                href={msg.attachment.fileUrl}
                download={msg.attachment.fileName}
                target="_blank"
                rel="noopener noreferrer"
                className="attachment-download"
                style={{ display: 'inline-block', marginTop: 6, padding: '6px 10px', border: '1px solid #ccc', borderRadius: 6, textDecoration: 'none', color: 'inherit' }}
              >
                📎 {msg.attachment.fileName}
                {msg.attachment.fileSize ? ` (${formatFileSize(msg.attachment.fileSize)})` : ''} — Download
              </a>
            )}
            {msg.retryText && onRetry && (
              <button type="button" className="retry-btn" onClick={() => onRetry(msg.retryText)}>Retry</button>
            )}
            {msg.retryLiveAgent && onRetryLiveAgent && (
              <button type="button" className="retry-btn" onClick={onRetryLiveAgent}>Try Again</button>
            )}
          </>
        )}
      </div>
      {msg.timestamp && (
        <div className={`msg-meta ${msg.role}`}>
          {isAssistantMsg ? agentLabel : 'You'} | {formatTime(msg.timestamp)}
        </div>
      )}
      {msg.proactiveMessage && (
        <div className="message assistant agent-ai">
          <div className="agent-label">Honeywell Assist</div>
          <div>{msg.proactiveMessage}</div>
        </div>
      )}
    </>
  );
}

export default ChatMessage;
